import { GridColDef, GridColumnVisibilityModel } from '@mui/x-data-grid';

export interface ExportModel {
    order: number;
    field: string;
    headerName: string;
}

export const getExportModels = (columns: GridColDef[], visibilityModel: GridColumnVisibilityModel = null): ExportModel[] => {
    var exportModels: ExportModel[] = [];
    columns.forEach((column, index) => {
        if (visibilityModel && (visibilityModel[column.field] === false || column.headerName.toLowerCase() === 'edit' || column.headerName.toLowerCase() === 'delete')) {
            return;
        }
        exportModels.push({
            order: index,
            field: column.field,
            headerName: column.headerName,
        });
    });

    exportModels.sort((a, b) => a.order - b.order);
    return exportModels;
};
